import produce from 'immer';
import {
  GET_PROVIDERS,
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_FAILED,
  UPDATE_PROVIDER_STATUS,
  UPDATE_PROVIDER_STATUS_FAILED,
  UPDATE_PROVIDER_STATUS_SUCCESS,
  CREATE_PROVIDER,
  CREATE_PROVIDER_SUCCESS,
  CREATE_PROVIDER_FAILED,
} from './constants';
import {Actions, State} from './interfaces';

export const initialState: State = {
  providerList: [],
  loading: false,
  count: 0,
  error: '',
  inactiveCardCount: 0,
  activeCardCount: 0,
};

export const ProviderReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_PROVIDERS:
        draft.loading = true;
        break;
      case GET_PROVIDERS_SUCCESS:
        // @ts-ignore
        draft.providerList = action.data;
        draft.count = action.count;
        draft.inactiveCardCount = action.inactiveCardCount;
        draft.activeCardCount = action.activeCardCount;
        draft.loading = false;
        break;
      case GET_PROVIDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case UPDATE_PROVIDER_STATUS:
        draft.loading = true;
        break;
      case UPDATE_PROVIDER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_PROVIDER_STATUS_FAILED:
        draft.loading = false;
        break;
      case CREATE_PROVIDER:
        draft.loading = true;
        break;
      case CREATE_PROVIDER_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_PROVIDER_FAILED:
        draft.loading = false;
        break;
      default:
        break;
    }
  });

export default ProviderReducer;
